<template>
  <div class="video-monitor-container">
    <el-card class="monitor-header">
      <div slot="header">
        <span>视频监控系统</span>
        <div class="control-panel">
          <el-select v-model="layout" placeholder="选择布局" size="small" @change="adjustLayout">
            <el-option label="2x2布局" :value="2"></el-option>
            <el-option label="3x3布局" :value="3"></el-option>
            <el-option label="1+5布局" :value="6"></el-option>
            <el-option label="全部" :value="0"></el-option>
          </el-select>
          <el-button size="small" type="primary" @click="refreshAll">刷新</el-button>
          <el-button size="small" type="success" @click="toggleMainSubStream">{{ useMainStream ? '切换子码流' : '切换主码流' }}</el-button>
        </div>
      </div>
    </el-card>
    
    <div class="video-grid" :class="'grid-layout-' + layout">
      <div v-for="camera in displayCameras" 
           :key="camera.id" 
           class="camera-container"
           :class="{'active-camera': selectedCamera === camera.id}"
           @click="selectCamera(camera.id)">
        <el-card class="camera-card">
          <div slot="header" class="camera-header">
            <span>{{ camera.name }}</span>
            <div class="camera-controls">
              <el-tooltip content="全屏" placement="top">
                <i class="el-icon-full-screen" @click.stop="fullScreen(camera.id)"></i>
              </el-tooltip>
              <el-tooltip content="截图" placement="top">
                <i class="el-icon-camera" @click.stop="takeSnapshot(camera.id)"></i>
              </el-tooltip>
              <el-tooltip content="刷新" placement="top">
                <i class="el-icon-refresh" @click.stop="refreshStream(camera.id)"></i>
              </el-tooltip>
            </div>
          </div>
          <div class="camera-player" :id="'camera-player-' + camera.id">
            <!-- 使用img标签展示MJPEG流或静态图片 -->
            <!-- 在生产环境中，应使用后端代理服务处理摘要认证: :src="getProxyStreamUrl(camera)" -->
            <img 
              v-if="camera.streamType === 'jpeg' || camera.streamType === 'mjpeg'" 
              :src="getStreamUrl(camera)" 
              :key="camera.timestamp" 
              style="width:100%;height:100%;" 
              @error="handleStreamError(camera.id)" 
            />
          </div>
          <div v-if="camera.status === 'error'" class="camera-error">
            <i class="el-icon-warning"></i>
            <p>视频加载失败</p>
            <el-button size="mini" @click.stop="refreshStream(camera.id)">重试</el-button>
          </div>
        </el-card>
      </div>
    </div>
    
    <!-- 云台控制面板 -->
    <el-drawer
      title="云台控制"
      :visible.sync="ptzVisible"
      direction="rtl"
      size="300px"
      :before-close="() => ptzVisible = false">
      <div class="ptz-container" v-if="selectedCamera !== null">
        <p class="ptz-title">{{ getSelectedCamera.name }} - 云台控制</p>
        
        <div class="ptz-panel">
          <div class="ptz-grid">
            <el-button @click="controlPTZ('leftup')" class="ptz-btn ptz-leftup" icon="el-icon-top-left"></el-button>
            <el-button @click="controlPTZ('up')" class="ptz-btn ptz-up" icon="el-icon-top"></el-button>
            <el-button @click="controlPTZ('rightup')" class="ptz-btn ptz-rightup" icon="el-icon-top-right"></el-button>
            <el-button @click="controlPTZ('left')" class="ptz-btn ptz-left" icon="el-icon-back"></el-button>
            <el-button @click="controlPTZ('auto')" class="ptz-btn ptz-center" icon="el-icon-refresh"></el-button>
            <el-button @click="controlPTZ('right')" class="ptz-btn ptz-right" icon="el-icon-right"></el-button>
            <el-button @click="controlPTZ('leftdown')" class="ptz-btn ptz-leftdown" icon="el-icon-bottom-left"></el-button>
            <el-button @click="controlPTZ('down')" class="ptz-btn ptz-down" icon="el-icon-bottom"></el-button>
            <el-button @click="controlPTZ('rightdown')" class="ptz-btn ptz-rightdown" icon="el-icon-bottom-right"></el-button>
          </div>
        </div>
        
        <div class="ptz-zoom">
          <span>变倍:</span>
          <el-button-group>
            <el-button size="small" @click="controlPTZ('zoomin')" icon="el-icon-zoom-in"></el-button>
            <el-button size="small" @click="controlPTZ('zoomout')" icon="el-icon-zoom-out"></el-button>
          </el-button-group>
        </div>
        
        <div class="ptz-focus">
          <span>聚焦:</span>
          <el-button-group>
            <el-button size="small" @click="controlPTZ('focusnear')">+</el-button>
            <el-button size="small" @click="controlPTZ('focusfar')">-</el-button>
          </el-button-group>
        </div>
        
        <div class="ptz-preset">
          <p>预置点</p>
          <div class="preset-grid">
            <el-button v-for="i in 6" :key="i" size="mini" @click="callPreset(i)">{{ i }}</el-button>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import axios from 'axios'

// 模拟后端代理服务的接口
// 在实际生产环境中，需要创建一个后端代理服务
const API_BASE_URL = '/api/proxy'; // 假设的后端代理服务基础URL

export default {
  name: 'VideoMonitor',
  data() {
    return {
      // NVR服务器配置
      nvrConfig: {
        internalAddress: 'http://8.134.78.41', // 内网地址
        externalAddress: 'http://8.134.78.41', // 外网地址
        username: 'admin',
        password: 'Few181818',
        port: 22300
      },
      // 摄像头列表
      cameraList: [
        {
          id: 1,
          name: '[D1] 东侧黑光球机',
          channel: 1,
          streamType: 'mjpeg',
          supportPTZ: true,
          timestamp: Date.now(),
          status: 'loading' // loading, active, error
        },
        {
          id: 2,
          name: '[D2] 西侧黑光球机',
          channel: 2,
          streamType: 'mjpeg',
          supportPTZ: false,
          timestamp: Date.now(),
          status: 'loading'
        },
        {
          id: 3,
          name: '[D3] 西侧桥面球机',
          channel: 3,
          streamType: 'mjpeg',
          supportPTZ: false,
          timestamp: Date.now(),
          status: 'loading'
        },
        {
          id: 4,
          name: '[D4] 东侧桥面球机',
          channel: 4,
          streamType: 'mjpeg',
          supportPTZ: true,
          timestamp: Date.now(),
          status: 'loading'
        },
        {
          id: 5,
          name: '[D5] 东侧桥柱枪机1',
          channel: 5,
          streamType: 'mjpeg',
          supportPTZ: false,
          timestamp: Date.now(),
          status: 'loading'
        },
        {
          id: 6,
          name: '[D6] 西侧枪机',
          channel: 6,
          streamType: 'mjpeg',
          supportPTZ: false,
          timestamp: Date.now(),
          status: 'loading'
        },
        {
          id: 7,
          name: '[D7] 东侧枪机',
          channel: 7,
          streamType: 'mjpeg',
          supportPTZ: false,
          timestamp: Date.now(),
          status: 'loading'
        },
        {
          id: 8,
          name: '[D8] 东侧桥柱枪机2',
          channel: 8,
          streamType: 'mjpeg',
          supportPTZ: true,
          timestamp: Date.now(),
          status: 'loading'
        }
      ],
      // 刷新定时器
      refreshTimers: {},
      // 界面设置
      layout: 2, // 默认2x2布局
      selectedCamera: null,
      ptzVisible: false,
      useMainStream: false, // 默认使用子码流
      environment: 'external' // external 或 external，用于切换内外网
    }
  },
  computed: {
    displayCameras() {
      if (this.layout === 0) {
        // 显示全部摄像头
        return this.cameraList
      } else if (this.layout === 6) {
        // 1+5布局，第一个摄像头大，其他5个小
        return this.cameraList.slice(0, 6)
      } else {
        // 2x2或3x3布局
        const maxCount = this.layout * this.layout
        return this.cameraList.slice(0, maxCount)
      }
    },
    nvrBaseUrl() {
      // return this.environment === 'internal' 
      //   ? this.nvrConfig.internalAddress 
      //   : this.nvrConfig.externalAddress
      
      // 暂时只使用外网地址，并确保加上端口号
      const baseUrl = this.nvrConfig.externalAddress;
      // 检查URL是否已包含端口号
      if(baseUrl.includes(':' + this.nvrConfig.port)) {
        return baseUrl;
      } else {
        // 确保添加端口号
        return `${baseUrl}:${this.nvrConfig.port}`;
      }
    },
    getSelectedCamera() {
      return this.cameraList.find(c => c.id === this.selectedCamera) || {}
    }
  },
  mounted() {
    this.initAllStreams()
    
    // 检测环境是内网还是外网
    // this.detectEnvironment()
    
    // 暂时默认使用外网环境
    this.environment = 'external'
    console.log('使用外网地址访问NVR')
    
    // 先检查摄像头状态
    this.checkCameraStatus()
  },
  beforeDestroy() {
    // 清理所有定时器
    Object.values(this.refreshTimers).forEach(timer => clearInterval(timer))
  },
  methods: {
    // 环境检测
    detectEnvironment() {
      // 暂时注释掉内网检测代码
      /*
      // 尝试ping内网地址
      axios.get(`${this.nvrConfig.internalAddress}/ISAPI/System/deviceInfo`, {
        timeout: 2000,
        auth: {
          username: this.nvrConfig.username,
          password: this.nvrConfig.password
        }
      }).then(() => {
        // 如果可以访问内网地址，则使用内网地址
        this.environment = 'internal'
        console.log('使用内网地址访问NVR')
        this.refreshAll()
      }).catch(() => {
        // 如果内网不通，切换到外网地址
        this.environment = 'external'
        console.log('使用外网地址访问NVR')
        this.refreshAll()
      })
      */
      
      // 直接使用外网配置
      this.environment = 'external'
      console.log('使用外网地址访问NVR')
      this.refreshAll()
    },
    
    // 获取流地址
    getStreamUrl(camera) {
      const streamType = this.useMainStream ? 1 : 2
      const channelCode = camera.channel * 100 + streamType
      
      // 由于前端无法直接实现digest认证，我们使用静态图片
      // 注意：此方法在真实环境中会因为摘要认证问题而失败
      return `${this.nvrBaseUrl}/ISAPI/Streaming/channels/${channelCode}/picture?t=${camera.timestamp}`;
    },
    
    // 定义通过后端代理获取视频流的方法 (推荐方式)
    getProxyStreamUrl(camera) {
      const streamType = this.useMainStream ? 1 : 2;
      const channelCode = camera.channel * 100 + streamType;
      
      // 通过后端代理服务的URL，后端负责处理摘要认证
      // 例如：/api/proxy/nvr/stream/101?t=timestamp
      return `${API_BASE_URL}/nvr/stream/${channelCode}?t=${camera.timestamp}`;
    },
    
    // 使用axios直接获取视频流（备选方案，如果URL认证不起作用可以尝试此方法）
    fetchVideoStream(camera) {
      const streamType = this.useMainStream ? 1 : 2
      const channelCode = camera.channel * 100 + streamType
      
      // 构建请求URL（不包含认证信息）
      const url = `${this.nvrBaseUrl}/ISAPI/Streaming/channels/${channelCode}/${camera.streamType === 'mjpeg' ? 'httppreview' : 'picture'}`;
      
      // 使用axios获取视频流，并通过auth选项传递认证信息
      return axios.get(url, {
        responseType: 'blob',
        auth: {
          username: this.nvrConfig.username,
          password: this.nvrConfig.password
        }
      }).then(response => {
        // 创建Blob URL
        const blob = new Blob([response.data], { type: camera.streamType === 'mjpeg' ? 'multipart/x-mixed-replace' : 'image/jpeg' });
        return URL.createObjectURL(blob);
      }).catch(error => {
        console.error(`获取视频流失败: ${camera.name}`, error);
        camera.status = 'error';
        return '';
      });
    },
    
    // 使用axios获取视频流（通过摘要认证）
    fetchStreamWithDigestAuth(camera) {
      const streamType = this.useMainStream ? 1 : 2
      const channelCode = camera.channel * 100 + streamType
      
      // 构建请求URL（不包含认证信息）
      const url = `${this.nvrBaseUrl}/ISAPI/Streaming/channels/${channelCode}/${camera.streamType === 'mjpeg' ? 'httppreview' : 'picture'}`;
      
      // 注意: 这里使用自定义的axios实例来处理摘要认证
      // 由于axios默认不支持摘要认证，我们需要在后端创建一个代理服务
      // 临时解决方案：返回静态URL但添加时间戳来防止缓存
      return `${url}?t=${Date.now()}`;
    },
    
    // 初始化所有视频流
    initAllStreams() {
      this.cameraList.forEach(camera => {
        if (camera.streamType === 'mjpeg' || camera.streamType === 'jpeg') {
          // 初始刷新
          this.refreshStream(camera.id);
          
          // 对于MJPEG和JPEG流，定期刷新
          this.refreshTimers[camera.id] = setInterval(() => {
            this.refreshStream(camera.id);
          }, camera.streamType === 'jpeg' ? 1000 : 5000); // JPEG每秒刷新，MJPEG每5秒刷新一次
        }
      });
      
      // 额外添加代码，检查摄像头视频流状态
      setInterval(() => {
        this.checkCameraStatus();
      }, 30000); // 每30秒检查一次摄像头状态
    },
    
    // 刷新指定摄像头
    refreshStream(cameraId) {
      const camera = this.cameraList.find(c => c.id === cameraId)
      if (!camera) return
      
      camera.timestamp = Date.now()
      camera.status = 'loading'
      
      // 仅更新时间戳触发图片重新加载
      console.log(`刷新摄像头: ${camera.name}，新时间戳: ${camera.timestamp}`);
    },
    
    // 刷新所有摄像头
    refreshAll() {
      this.cameraList.forEach(camera => {
        this.refreshStream(camera.id)
      })
    },
    
    // 处理视频流加载错误
    handleStreamError(cameraId) {
      const camera = this.cameraList.find(c => c.id === cameraId)
      if (!camera) return
      
      camera.status = 'error'
      this.$message.error(`摄像头 ${camera.name} 视频流加载失败`)
    },
    
    // 调整布局
    adjustLayout() {
      // 清空选择的摄像头
      this.selectedCamera = null
      this.ptzVisible = false
      
      // 根据新布局刷新视频流
      this.$nextTick(() => {
        this.refreshAll()
      })
    },
    
    // 选择摄像头
    selectCamera(cameraId) {
      this.selectedCamera = cameraId
      const camera = this.cameraList.find(c => c.id === cameraId)
      
      // 如果支持云台，显示控制面板
      if (camera && camera.supportPTZ) {
        this.ptzVisible = true
      }
    },
    
    // 控制云台
    controlPTZ(command) {
      if (!this.selectedCamera) return
      
      const camera = this.cameraList.find(c => c.id === this.selectedCamera)
      if (!camera || !camera.supportPTZ) return
      
      // ISAPI云台控制接口
      const apiUrl = `${this.nvrBaseUrl}/ISAPI/PTZCtrl/channels/${camera.channel}/continuous`
      
      // 根据不同命令设置PTZ参数
      let ptzParams = { pan: 0, tilt: 0, zoom: 0 }
      
      switch(command) {
        case 'up': ptzParams.tilt = 5; break
        case 'down': ptzParams.tilt = -5; break
        case 'left': ptzParams.pan = -5; break
        case 'right': ptzParams.pan = 5; break
        case 'leftup': ptzParams.pan = -5; ptzParams.tilt = 5; break
        case 'rightup': ptzParams.pan = 5; ptzParams.tilt = 5; break
        case 'leftdown': ptzParams.pan = -5; ptzParams.tilt = -5; break
        case 'rightdown': ptzParams.pan = 5; ptzParams.tilt = -5; break
        case 'zoomin': ptzParams.zoom = 5; break
        case 'zoomout': ptzParams.zoom = -5; break
        case 'focusnear': /* 聚焦控制，需另外API */ break
        case 'focusfar': /* 聚焦控制，需另外API */ break
        case 'auto': /* 自动控制，需另外API */ break
      }
      
      // 发送PTZ控制命令
      axios.put(apiUrl, ptzParams, {
        auth: {
          username: this.nvrConfig.username,
          password: this.nvrConfig.password
        },
        headers: { 'Content-Type': 'application/xml' }
      }).catch(error => {
        console.error('PTZ控制失败', error)
        this.$message.error('云台控制失败，请检查网络连接和设备状态')
      })
    },
    
    // 调用预置点
    callPreset(presetId) {
      if (!this.selectedCamera) return
      
      const camera = this.cameraList.find(c => c.id === this.selectedCamera)
      if (!camera || !camera.supportPTZ) return
      
      const apiUrl = `${this.nvrBaseUrl}/ISAPI/PTZCtrl/channels/${camera.channel}/presets/${presetId}/goto`
      
      axios.put(apiUrl, {}, {
        auth: {
          username: this.nvrConfig.username,
          password: this.nvrConfig.password
        }
      }).catch(error => {
        console.error('调用预置点失败', error)
        this.$message.error(`调用预置点${presetId}失败`)
      })
    },
    
    // 全屏显示
    fullScreen(cameraId) {
      // 直接使用浏览器全屏API
      const container = document.getElementById('camera-player-' + cameraId)
      if (!container) return
      
      if (document.fullscreenElement) {
        document.exitFullscreen()
      } else {
        container.requestFullscreen().catch(err => {
          this.$message.error(`全屏失败: ${err.message}`)
        })
      }
    },
    
    // 截图
    takeSnapshot(cameraId) {
      const camera = this.cameraList.find(c => c.id === cameraId)
      if (!camera) return
      
      // 对于图片类型，直接下载当前图像
      const imgElement = document.querySelector(`#camera-player-${cameraId} img`)
      if (imgElement) {
        // 创建canvas
        const canvas = document.createElement('canvas')
        canvas.width = imgElement.naturalWidth || imgElement.width
        canvas.height = imgElement.naturalHeight || imgElement.height
        
        // 将图像绘制到canvas
        const ctx = canvas.getContext('2d')
        ctx.drawImage(imgElement, 0, 0, canvas.width, canvas.height)
        
        try {
          // 转换为blob并下载
          canvas.toBlob(blob => {
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = `${camera.name}_${new Date().toISOString().replace(/:/g, '-')}.jpg`
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            URL.revokeObjectURL(url)
          }, 'image/jpeg', 0.95)
          this.$message.success('截图已保存')
        } catch (err) {
          console.error('截图失败', err)
          this.$message.error('截图失败')
        }
      }
    },
    
    // 切换主/子码流
    toggleMainSubStream() {
      this.useMainStream = !this.useMainStream
      this.$message.info(`已切换到${this.useMainStream ? '主' : '子'}码流，正在刷新...`)
      this.refreshAll()
    },
    
    // 检查摄像头状态
    checkCameraStatus() {
      // 测试已证明：只有摘要认证(Digest Auth)能够成功访问ISAPI接口
      
      // 方法1: 通过后端代理服务 (推荐生产环境使用)
      const proxyUrl = `${API_BASE_URL}/nvr/device-info`;
      console.log('推荐方法: 通过后端代理访问NVR设备信息', proxyUrl);
      
      // 实际项目中应该用这个方法，但现在我们还没有后端代理
      /*
      axios.get(proxyUrl)
        .then(response => {
          console.log('NVR设备信息获取成功', response.data);
          this.cameraList.forEach(camera => {
            camera.status = 'active';
          });
        })
        .catch(error => {
          console.error('NVR设备信息获取失败', error);
          this.cameraList.forEach(camera => {
            camera.status = 'error';
          });
        });
      */
      
      // 方法2: 直接访问尝试 (在浏览器中会失败)
      const directUrl = `${this.nvrBaseUrl}/ISAPI/System/deviceInfo`;
      console.log('正在尝试直接访问NVR设备信息：', directUrl);
      console.log('注意：此方法在浏览器中会失败，因为浏览器不支持摘要认证');
      
      // 与Python测试中成功的方式一致，但浏览器中的axios不支持摘要认证
      axios({
        method: 'get',
        url: directUrl,
        auth: {
          username: this.nvrConfig.username,
          password: this.nvrConfig.password,
          // axios默认不支持digest认证，这里只是示意
          digest: true
        },
        timeout: 5000
      }).catch(error => {
        console.error('直接访问NVR预期失败，需要后端代理：', error.message);
        
        // 临时：将摄像头状态设为活动，以便显示静态图片
        setTimeout(() => {
          this.cameraList.forEach(camera => {
            camera.status = 'active';
          });
        }, 1000);
      });
    }
  }
}
</script>

<style scoped>
.video-monitor-container {
  padding: 20px;
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
}

.monitor-header {
  margin-bottom: 20px;
}

.monitor-header .el-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.control-panel {
  display: flex;
  gap: 10px;
}

.video-grid {
  display: grid;
  grid-gap: 10px;
  flex: 1;
  min-height: 0;
}

/* 不同的布局 */
.grid-layout-2 {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.grid-layout-3 {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

/* 1+5布局: 1个大的，5个小的 */
.grid-layout-6 {
  grid-template-columns: 2fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
}
.grid-layout-6 .camera-container:first-child {
  grid-column: 1;
  grid-row: 1 / span 3;
}

/* 全部布局 */
.grid-layout-0 {
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-auto-rows: 1fr;
}

.camera-container {
  height: 100%;
  position: relative;
  transition: all 0.3s;
}

.active-camera {
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.7);
  transform: scale(1.01);
  z-index: 2;
}

.camera-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.camera-card .el-card__body {
  flex: 1;
  padding: 0;
  position: relative;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.camera-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
}

.camera-controls {
  display: flex;
  gap: 10px;
}

.camera-controls i {
  cursor: pointer;
  font-size: 16px;
  color: #606266;
}

.camera-controls i:hover {
  color: #409EFF;
}

.camera-player {
  width: 100%;
  height: 100%;
  background-color: #000;
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.camera-error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.camera-error i {
  font-size: 40px;
  color: #F56C6C;
  margin-bottom: 10px;
}

/* PTZ控制面板样式 */
.ptz-container {
  padding: 20px;
}

.ptz-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.ptz-panel {
  margin-bottom: 20px;
}

.ptz-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-gap: 5px;
  max-width: 200px;
  margin: 0 auto;
}

.ptz-btn {
  padding: 10px;
  height: auto;
}

.ptz-zoom,
.ptz-focus {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ptz-preset {
  margin-top: 30px;
}

.ptz-preset p {
  margin-bottom: 10px;
  font-weight: bold;
}

.preset-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 5px;
}
</style> 